import { render, staticRenderFns } from "./EmitirEtiqueta.vue?vue&type=template&id=52bb7762&"
import script from "./EmitirEtiqueta.vue?vue&type=script&lang=js&"
export * from "./EmitirEtiqueta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports